import { MAX_FILE_MB } from "./fileUploadLimits"

const fileUploadCopy = (wizardCopy) => ({
  browseFiles: wizardCopy.browseFiles,
  replace: wizardCopy.replace,
  view: wizardCopy.view,
  documentOnFile: wizardCopy.documentOnFile,
  uploaded: wizardCopy.uploaded,
  attached: wizardCopy.attached,
  hint: wizardCopy.fileUploadHint.replace("{{limit}}", MAX_FILE_MB),
  validating: wizardCopy.validatingDocument,
  failure: wizardCopy.fileValidationFailed,
  keepOnFile: wizardCopy.keepOnFile,
})

export default fileUploadCopy
